import React, { useState } from 'react';

import InputField from 'components/LoginForm/Input';

const encode = (data) =>
  Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');

const ExhibitorView = () => {
  const [userInput, setUserInput] = useState({
    company: '',
    name: '',
    email: '',
    phone: '',
  });

  const [popup, setPopup] = useState(false);

  const handleSubmit = (e) => {
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': 'contact',
        ...userInput,
      }),
    })
      .then(() => setPopup(true))
      .catch((error) => alert(error));

    e.preventDefault();
  };

  const handleChange = (e) => {
    const input = userInput;
    input[e.target.name] = e.target.value;
    setUserInput(input);
  };

  return (
    <div className="exhibitorView">
      <div className="exhibitorView__bg" />
      <div className="exhibitorView__content">
        <div className="exhibitorView__content--intro">
          <h1>{'Exhibitor Information'}</h1>
          <img
            src="https://front.travpromobile.com/848/xpos-exhibitors-page2.png"
            alt=""
            className="showLogos"
          />
          <img
            src="https://front.travpromobile.com/848/xpos-exhibitors-page3.png"
            alt=""
            className="showLogos-mobile"
          />
          <p>
            {
              "Interested in exhibiting at one of our Xpos? Please complete this form and we'll get back to you shortly for pricing options."
            }
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <input type="hidden" name="form-name" value="contact" />
          <InputField
            change={handleChange}
            fieldType="text"
            fieldName="company"
            fieldPlaceholder="Company *"
            icon="home"
          />

          <InputField
            change={handleChange}
            fieldType="text"
            fieldName="name"
            fieldPlaceholder="Name *"
            icon="user"
          />

          <InputField
            change={handleChange}
            fieldType="email"
            fieldName="email"
            fieldPlaceholder="Email *"
            icon="at"
          />

          <InputField
            change={handleChange}
            fieldType="text"
            fieldName="phone"
            fieldPlaceholder="Phone Number"
            icon="phone"
            required={false}
          />

          <div className="buttonWrapper">
            <button type="submit">{'Submit'}</button>
          </div>
        </form>
      </div>
      {popup && (
        <div className="exhibitorView__popup">
          <div className="exhibitorView__popup--bg" />
          <div className="exhibitorView__popup--content">
            <h1 className="h1">{'Thanks for your submission!'}</h1>
            <p>
              {
                'Our sales team will be in touch shortly to discuss your interest in the VIRTUAL TRAVEL XPOS.'
              }
              <br />
              <a
                href="https://front.travpromobile.com/848/VIRTUAL+TRAVEL+XPOS+-+price+sheet.pdf"
                target="_blank"
                rel="noreferrer noopener"
              >
                {'Click here for prices'}
              </a>
              {'.'}
            </p>
            <button
              type="button"
              onClick={() => {
                window.location.href = 'https://www.virtualtravelxpos.com/';
              }}
            >
              {'Close and return to VIRTUAL TRAVEL XPOS'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExhibitorView;
